import { GenericService } from './generic.service';
import { Medication } from '@/models';

export class MedicationService extends GenericService<Medication> {
  constructor() {
    super('v1/medications');
  }
}
